"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacilityAreaActions = useFacilityAreaActions;
var react_1 = require("react");
var area_1 = require("../features/apis/area");
var message_dialog_1 = require("../features/thunks/message-dialog");
var dialogs_1 = require("../interfaces/dialogs");
var hooks_1 = require("../store/hooks");
var confirm_then_run_1 = require("../utils/confirm-then-run");
/** Adding areas, assigning/removing area managers, and deleting areas, from the facility detail page. */
function useFacilityAreaActions(facilityId, facilityName, canUpdateArea, canDeleteArea) {
    var _this = this;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _a = (0, react_1.useState)(null), editingArea = _a[0], setEditingArea = _a[1];
    var _b = (0, react_1.useState)(null), managingAreaManagers = _b[0], setManagingAreaManagers = _b[1];
    var _c = (0, react_1.useState)(null), deletingAreaId = _c[0], setDeletingAreaId = _c[1];
    var _d = (0, react_1.useState)(null), removingAreaManager = _d[0], setRemovingAreaManager = _d[1];
    var _e = (0, area_1.useCreateAreaMutation)(), createArea = _e[0], isAddingAreas = _e[1].isLoading;
    var deleteArea = (0, area_1.useDeleteAreaMutation)()[0];
    var _f = (0, area_1.useAddAreaManagersMutation)(), addAreaManagers = _f[0], isAssigningAreaManagers = _f[1].isLoading;
    var removeAreaManager = (0, area_1.useRemoveAreaManagerMutation)()[0];
    var handleAddAreas = function (areaLibraryIds) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!facilityId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createArea({ facilityId: facilityId, areaLibraryIds: areaLibraryIds }).unwrap()];
                case 1:
                    response = _a.sent();
                    if (!response.success) {
                        throw new Error(response.message || "Unable to add areas.");
                    }
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Areas added",
                            body: "Added ".concat(areaLibraryIds.length, " area(s) to \"").concat(facilityName !== null && facilityName !== void 0 ? facilityName : "this facility", "\"."),
                            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
                        })).catch(function () { })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAssignAreaManagers = function (managerIds) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!managingAreaManagers) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, addAreaManagers({ areaId: managingAreaManagers.id, managerIds: managerIds }).unwrap()];
                case 1:
                    response = _a.sent();
                    if (!response.success) {
                        throw new Error(response.message || "Unable to assign managers.");
                    }
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Managers assigned",
                            body: "Added ".concat(managerIds.length, " manager(s) to \"").concat(managingAreaManagers.display_name || managingAreaManagers.name, "\"."),
                            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
                        })).catch(function () { })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveAreaManager = function (area, managerId) {
        var _a, _b;
        if (!canUpdateArea) {
            return;
        }
        var managerName = ((_b = (_a = area.managers) === null || _a === void 0 ? void 0 : _a.find(function (manager) { return manager.id === managerId; })) === null || _b === void 0 ? void 0 : _b.name) || "this manager";
        var areaName = area.display_name || area.name || "this area";
        (0, confirm_then_run_1.confirmThenRun)({
            dispatch: dispatch,
            confirmHeader: "Remove manager",
            confirmBody: "Remove ".concat(managerName, " as a manager of \"").concat(areaName, "\"?"),
            confirmLabel: "Remove Manager",
            action: function () { return removeAreaManager({ areaId: area.id, managerId: managerId }).unwrap(); },
            successHeader: "Manager removed",
            successBody: "".concat(managerName, " is no longer a manager of \"").concat(areaName, "\"."),
            failureHeader: "Remove manager failed",
            failureBody: "Unable to remove this manager. Please try again.",
            onStart: function () { return setRemovingAreaManager({ areaId: area.id, managerId: managerId }); },
            onSettled: function () { return setRemovingAreaManager(null); },
        });
    };
    var handleDeleteArea = function (area) {
        if (!canDeleteArea) {
            return;
        }
        var areaName = area.display_name || area.name || "this area";
        (0, confirm_then_run_1.confirmThenRun)({
            dispatch: dispatch,
            confirmHeader: "Delete area",
            confirmBody: "Delete \"".concat(areaName, "\"? This cannot be undone."),
            confirmLabel: "Delete Area",
            action: function () { return deleteArea({ id: area.id }).unwrap(); },
            successHeader: "Area deleted",
            successBody: "\"".concat(areaName, "\" has been deleted."),
            failureHeader: "Delete failed",
            failureBody: "Unable to delete this area. It may still have linked grow cycles or devices — unlink them first.",
            onStart: function () { return setDeletingAreaId(area.id); },
            onSettled: function () { return setDeletingAreaId(null); },
        });
    };
    return {
        editingArea: editingArea,
        setEditingArea: setEditingArea,
        managingAreaManagers: managingAreaManagers,
        setManagingAreaManagers: setManagingAreaManagers,
        deletingAreaId: deletingAreaId,
        removingAreaManager: removingAreaManager,
        isAddingAreas: isAddingAreas,
        isAssigningAreaManagers: isAssigningAreaManagers,
        handleAddAreas: handleAddAreas,
        handleAssignAreaManagers: handleAssignAreaManagers,
        handleRemoveAreaManager: handleRemoveAreaManager,
        handleDeleteArea: handleDeleteArea,
    };
}
